import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-privacy',
  standalone: true,
  imports: [ CommonModule, TranslateModule, RouterLink ],
  templateUrl: './privacy.component.html',
  styleUrls: [ './privacy.component.scss' ]
})
export class PrivacyComponent {
  private readonly route = inject( ActivatedRoute );
  private readonly translate = inject( TranslateService );

  readonly policy$: Observable<string> = this.route.paramMap.pipe(
    map( ( params ) => params.get( 'policy' ) || 'privacy_policy' )
  );

  getTitle( policy: string ): string {
    const titles: Record<string, string> = {
      terms_of_services: this.translate.instant( 'footer.terms_of_services' ),
      privacy_policy: this.translate.instant( 'footer.privacy_policy' ),
      impressum: this.translate.instant( 'footer.impressum' ),
      about: this.translate.instant( 'footer.about' )
    };

    return titles[policy] || this.translate.instant( 'footer.privacy_policy' );
  }

  getContentKey( policy: string ): string {
    return `policy.${policy}`;
  }
}
